import helper from './helper'

const getAccountsUrlWithParameters = helper.getAccountsUrlWithParameters
// const getWorkerUrlWithParameters = helper.getWorkerUrlWithParameters
const getSignerUrlWithParameters = helper.getSignerUrlWithParameters

export default {
  SELECTORS: {
    ACCOUNTS: {
      COUNTRY: (gets = null) => getAccountsUrlWithParameters(
        /**
         * Получает список стран
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения списка стран
         */
        'selectors|contacts|country',
        'get',
        {},
        gets
      ),
      COUNTRY_CODE: (gets = null) => getAccountsUrlWithParameters(
        /**
         * Получает телефонные коды стран
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения телефонных кодов
         */
        'selectors|contacts|country|code',
        'get',
        {},
        gets
      ),
      LANGUAGES: (gets = null) => getAccountsUrlWithParameters(
        /**
         * Получает доступные языки
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения списка языков
         */
        'selectors|users|languages',
        'get',
        {},
        gets
      ),
      ACCOUNTS: (gets = null) => getAccountsUrlWithParameters(
        /**
         * Получает дополнительные аккаунты пользователя
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения дополнительных аккаунтов
         */
        'selectors|users|additional|accounts',
        'get',
        {},
        gets
      )
    },
    SIGNER: {
      RECIPIENTS: (gets = null) => getSignerUrlWithParameters(
        /**
         * Получает список получателей для документооборота
         * @param {Object} gets - дополнительные query параметры (опционально)
         * @returns {string} URL для получения списка получателей
         */
        'selectors|recipients',
        'get',
        {},
        gets
      )
    }
  }
}
